import type { ReactNode } from 'react'

import { cn } from 'utils/classMerge'

type StepContentProps = {
  children: ReactNode
}

export const StepContent = ({ children }: StepContentProps) => {
  return (
    <div
      className={cn(
        'tw-box-content',
        'tw-w-auto',
        'tw-h-full',
        'tw-flex',
        'tw-flex-1',
        'tw-flex-col',
        'tw-justify-center',
        'lt:tw-h-auto',
      )}
    >
      {children}
    </div>
  )
}
